export { default } from './CmsPage.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/CmsPage/index.js